import { storageGet, storageRemove, storageSet } from '~/shared/lib/storage'
import { BaseAuthStore } from './BaseAuthStore'

type FallbackToken = string | null
/**
 * The default auth store for browsers with auto fallback
 * to runtime/memory if local storage is undefined (eg. in node env).
 */
export class LocalAuthStore extends BaseAuthStore {
  private readonly storageKeyToken: string

  private fallbackToken: FallbackToken = null

  constructor(storageKeyToken: string) {
    super()

    this.storageKeyToken = storageKeyToken
  }

  get token(): string {
    const storageByKey = storageGet<string>(this.storageKeyToken)
    return storageByKey || this.fallbackToken || ''
  }

  saveToken(token: string) {
    const { isMemoryUpdate } = storageSet<string>(this.storageKeyToken, token)

    if (isMemoryUpdate) {
      this.fallbackToken = token
    }

    super.saveToken(token)
  }

  clearToken() {
    storageRemove(this.storageKeyToken)
    this.fallbackToken = null
    super.clearToken()
  }
}
